const HOP_BY_HOP_HEADERS = new Set([
  'connection',
  'keep-alive',
  'proxy-authenticate',
  'proxy-authorization',
  'te',
  'trailers',
  'transfer-encoding',
  'upgrade',
]);

const BODY_HEADERS = new Set(['content-length', 'content-type', 'content-encoding']);

export function methodAllowsRequestBody(method: string): boolean {
  const normalized = method.toUpperCase();
  return normalized !== 'GET' && normalized !== 'HEAD';
}

/**
 * Adjust headers before forwarding a browser preview request to localhost.
 * Strips cross-origin browser context and body metadata when no body is sent.
 */
export function prepareLocalProxyRequestHeaders(
  method: string,
  headers: Record<string, string> | undefined,
  sendingBody: boolean,
): Record<string, string> {
  const out: Record<string, string> = {};

  for (const [key, value] of Object.entries(headers ?? {})) {
    const lower = key.toLowerCase();
    if (lower === 'host') continue;
    if (HOP_BY_HOP_HEADERS.has(lower)) continue;
    if (lower === 'origin' || lower === 'referer') continue;
    if (!sendingBody && BODY_HEADERS.has(lower)) continue;
    out[key] = value;
  }

  return out;
}
